<template>
  <div class="page tutorial">
    <div class="header">
	    <img src="@/assets/Qr-Code.jpg" />
    </div>
    <div class="tuto">
      <h1>Comment visiter ?</h1>
      <p>
        Flashez les QR Codes sur les<br>
        bornes le long du parcours:<br/>
        Du contenu interactif vous est<br> 
        alors proposé.<br/>
        Découvrez ainsi pas à pas<br> 
        toute l'histoire du Bois de<br> 
        Riquet.
      </p>
    </div>
    <div class="cta">
      <router-link class="buttonLink" to='/geolocation'>Allez à la carte</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  components: {
    
  },
  data: () => ({
  }),
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.page.tutorial {
  display: flex;
  flex-direction: column;
  justify-content: space-between;



  @media screen and (min-width: 500px) {
    justify-content: space-evenly;
  }

  .header {
    margin-top: 40px;
    border-radius: 100%;
    overflow: hidden;
    width: 200px;
    height: 200px;
    display: flex;
    margin: 40px auto 0;

    img {
      object-fit: cover;
    }
  }

  .cta {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

p {
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// src/views/Tutorial.vue